document.addEventListener("DOMContentLoaded", function () {
  let checkExist = setInterval(function () {
    let swatchKing = document.querySelector("variant-swatch-king")
    if (swatchKing) {
      swatchKing.classList.add("variantsShowed")

      clearInterval(checkExist)

      setTimeout(function () {
        let paragraphColor = document.createElement("p")
        let spanColor = document.createElement("span")
        let spanSize = document.createElement("span")
        let linkSize = document.createElement("a")

        spanColor.textContent = document.querySelector(
          "div[option-name='Color'] ul span"
        ).textContent

        linkSize.href = "/pages/size-guide"
        linkSize.textContent = "Size guide"
        linkSize.target = "_blank"

        spanSize.classList.add("sizeGuide")
        spanSize.appendChild(linkSize)

        paragraphColor.classList.add("currentColor")
        paragraphColor.textContent = "Color - "
        paragraphColor.appendChild(spanColor)

        let swatchListColor = document.querySelector("ul.swatch-view-image")
        let swatchListSize = document.querySelector("#swatch-option2 ul.swatch-view-button")

        if (swatchListColor) {
          swatchListColor.parentNode.insertBefore(paragraphColor, swatchListColor)
        }

        if (swatchListSize) {
          const swatchSize = document.querySelector("#swatch-option2")
          if (swatchSize) {
            swatchSize.parentNode.insertBefore(spanSize, swatchSize)
          }

          const hasApparelSize = Array.from(
            swatchListSize.querySelectorAll("span[swatch-inside='true']")
          ).some(el => ["S", "M", "L"].includes(el.textContent.trim().toUpperCase()))

          if (!hasApparelSize) {
            createSizeTab()
          }
        }
      }, 20)
    }
  }, 1000)
})

function createSizeTab() {
  const sizeTabContainer = document.createElement("div")
  const sizeTabWrapper = document.createElement("div")
  const movingBg = document.createElement("div") // Moving background

  sizeTabContainer.classList.add("size-tab-container")
  sizeTabWrapper.classList.add("size-tab-wrapper")
  movingBg.classList.add("size-tab-bg")

  sizeTabWrapper.appendChild(movingBg) // Append background inside wrapper

  // Detect if the product is Kids (by text in the product title)
  const productTitle = document.querySelector(".product__title")?.textContent.trim().toLowerCase() || ""
  const isKids = productTitle.includes("kids")

  // If it's a Kids product -> show only "US Men"
  const sizeOptions = isKids
    ? ["US Men"]
    : ["US Men", "US Women", "EU", "UK", "Mondo"]

  const regionMapping = {
    "US Men": "US",
    "US Women": "US_Women",
    EU: "EU",
    UK: "UK",
    Mondo: "Mondo",
  }

  sizeOptions.forEach((option, index) => {
    const tabButton = document.createElement("button")
    tabButton.textContent = option
    tabButton.classList.add("size-tab")

    if (index === 0) {
      tabButton.classList.add("active")
      setTimeout(() => updateTabIndicator(tabButton), 50) // Ensure background is set at start
    }

    sizeTabWrapper.appendChild(tabButton)
  })

  sizeTabContainer.appendChild(sizeTabWrapper)

  const swatchSize = document.querySelector("#swatch-option2")
  if (swatchSize) {
    swatchSize.parentNode.insertBefore(sizeTabContainer, swatchSize)
  }

  sizeTabWrapper.addEventListener("click", function (event) {
    if (event.target.classList.contains("size-tab")) {
      const previousActive = document.querySelector(".size-tab.active")
      if (previousActive) previousActive.classList.remove("active")

      updateTabIndicator(event.target)

      // Delay the text color switch for 150ms
      setTimeout(() => {
        event.target.classList.add("active")
      }, 150)

      const selectedRegion = event.target.textContent
        .trim()
        .replace("US Men", "US")
        .replace("US Women", "US_Women")

      translateSizes(selectedRegion)
    }
  })

  // ✅ Periodically check and fix the background position (for external app delay issues)
  setInterval(() => {
    const activeTab = document.querySelector(".size-tab.active")
    if (activeTab) {
      updateTabIndicator(activeTab)
    }
  }, 400)
}

function updateTabIndicator(activeTab) {
  const movingBg = document.querySelector(".size-tab-bg")
  if (!movingBg || !activeTab) return

  const { offsetLeft, offsetWidth } = activeTab
  movingBg.style.transform = `translateX(${offsetLeft}px)`
  movingBg.style.width = `${offsetWidth}px`
}
